import { useHistory, useParams } from 'react-router-dom';

import Page from 'flow/components/Setting/Page';
import Loading from 'flow/components/ui-components/Loading';
import { useAiDigestServiceSettings } from 'flow/hooks/api/useAiDigestServiceSettings';
import useAppContext from 'flow/hooks/useAppContext';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

import useTranscriptionSettingsReady from '../useTranscriptionSettingsReady';

import DailySummaryEmailSetting from './DailySummaryEmailSetting';
import WeeklySummaryEmailSetting from './WeeklySummaryEmailSetting';

const SettingsTranscriptionsDigest = () => {
    const { i18next } = useAppContext();
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();
    const history = useHistory();
    const ready = useTranscriptionSettingsReady();
    const { isError } = useAiDigestServiceSettings(extensionKey);

    if (!ready) {
        return <Loading />;
    }

    return (
        <Page
            childrenClassName="mx-auto w-full max-w-screen-sm p-3"
            header="settings.transcriptions.call_summary"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.transcriptions'], {
                        extensionKey,
                    }),
                )
            }
        >
            <p className="mb-4 text-sm text-gray-600">
                {i18next.t('settings.transcriptions.call_summary.description')}
            </p>

            <DailySummaryEmailSetting
                extensionKey={extensionKey}
                disabled={isError}
            />
            <WeeklySummaryEmailSetting
                extensionKey={extensionKey}
                disabled={isError}
            />
            {isError && (
                <p className="mt-4 px-2 text-sm text-gray-500">
                    {i18next.t(
                        'settings.transcriptions.call_summary.load_error',
                    )}
                </p>
            )}
        </Page>
    );
};

export default SettingsTranscriptionsDigest;
